module.exports = __webpack_public_path__ + "img/hush.78bc1743.svg";